module.exports = __webpack_public_path__ + "static/media/volunteer-network.171503c1.jpg";